/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getChannelOptions(conversationID, params = {}, options = {}) {
    return axios.get(`${this.url}/${conversationID}/channel_switches`, {
      ...options,
      params,
    });
  }

  switchChannel(conversationID, data) {
    return axios.post(`${this.url}/${conversationID}/channel_switches`, data);
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
